import { on, off, throttle, isInViewport } from './utils/_fn';

/* ---------------------------------------- [START] Swiper 初始設定 */
let thumbsSwiper, contentsSwiper, clientSwiper;

$(function () {
  /* ---------------- deco_circle lazy 圖---------------- */
  function forceLoadCircleImage(callback) {
    const $img = $('.deco_circle');
    if (!$img.length) return callback && callback();
    let loaded = 0;
    $img.each(function () {
      const $el = $(this);
      const src = $el.attr('src') || $el.attr('data-src');
      if (!src) return;
      if (!$el.attr('src')) $el.attr('src', src);
      if (this.complete) {
        if (++loaded >= $img.length) callback && callback();
      } else {
        $el.on('load', function () {
          if (++loaded >= $img.length) callback && callback();
        });
      }
    });
  }

  /* ---------------- 影片工具：iOS Chrome 解鎖（序列）＋播放兜底 ---------------- */
  const ua = navigator.userAgent || '';
  const IS_IOS = /\b(iPad|iPhone|iPod)\b/i.test(ua) || (/\bMacintosh\b/.test(ua) && 'ontouchend' in document);
  const IS_CRIOS = /\bCriOS\/\d+/.test(ua); // iOS Chrome
  let iosUnlocked = !IS_IOS; // 非 iOS 視為已解鎖

  function applyRenderHints(v) {
    if (!v || v.__hints) return;
    v.__hints = true;
    v.muted = true;
    v.setAttribute('muted','');
    v.setAttribute('playsinline','');
    v.setAttribute('webkit-playsinline','');
    v.playsInline = true;
    v.loop = true;
    try {
      v.style.transform = v.style.transform || 'translateZ(0)';
      v.style.backfaceVisibility = v.style.backfaceVisibility || 'hidden';
      v.style.webkitBackfaceVisibility = v.style.webkitBackfaceVisibility || 'hidden';
      v.style.willChange = v.style.willChange || 'opacity, transform';
    } catch(e){}
  }

  function getSourceURL(v) {
    const s = v && v.querySelector('source');
    return s ? (s.getAttribute('src') || s.src || null) : null;
  }
  function ensureVideoWired(v) {
    if (!v || v.__wired) return;
    const url = getSourceURL(v);
    if (url) {
      try { v.removeAttribute('src'); } catch(e){}
      v.src = url;
    }
    v.setAttribute('preload','auto');
    try { v.load(); } catch(e){}
    v.__wired = true;
  }

  function stopAllVideosIn(swiper) {
    if (!swiper || !swiper.slides) return;
    $(swiper.slides).find('video').each(function () {
      applyRenderHints(this);
      try { this.pause(); } catch(e){}
      // 不 reset currentTime；不動 display/visibility（保留高度與遮罩）
    });
  }

  function getActiveVideo(swiper) {
    if (!swiper || !swiper.slides) return null;
    const s = swiper.slides[swiper.activeIndex];
    if (!s) return null;
    return $(s).find('video').get(0) || null;
  }
  function getVideoByIndex(swiper, idx) {
    if (!swiper || !swiper.slides) return null;
    const s = swiper.slides[idx];
    if (!s) return null;
    return $(s).find('video').get(0) || null;
  }

  function tryPlay(v) {
    if (!v) return;
    const p = v.play();
    if (p && p.catch) p.catch(()=>{});
  }

  // ----------------播放：事件＋延時多次兜底；immediate=true 表示「同一手勢回合同步播放」
  function primeAndPlay(v, immediate = false) {
    if (!v) return;
    applyRenderHints(v);
    ensureVideoWired(v);

    const playNow   = () => tryPlay(v);
    const playLater = () => requestAnimationFrame(playNow);

    if (immediate) { playNow(); return; } // 手勢同步階段

    if (v.readyState >= 2) {
      playLater();
    } else {
      try { v.load(); } catch(e){}
      v.addEventListener('loadeddata',      playLater, { once:true });
      v.addEventListener('canplay',         playLater, { once:true });
      v.addEventListener('canplaythrough',  playLater, { once:true });
      setTimeout(playLater, 200);
      setTimeout(playLater, 600);
      setTimeout(playLater, 1200);
    }
  }

  function playActiveVideo(swiper) {
    if (!swiper) return;
    stopAllVideosIn(swiper);
    const v = getActiveVideo(swiper);
    if (IS_IOS && !iosUnlocked) return; // 等待首次手勢解鎖
    primeAndPlay(v);
  }

  // ----------------預先 wiring 當前與左右鄰居，避免切到才拉流
  function preloadNeighbors(swiper) {
    if (!swiper || !swiper.slides) return;
    [swiper.activeIndex - 1, swiper.activeIndex, swiper.activeIndex + 1].forEach(i => {
      const s = swiper.slides[i];
      if (!s) return;
      const v = $(s).find('video').get(0);
      if (v) { applyRenderHints(v); ensureVideoWired(v); }
    });
  }

  // ----------------iOS 手勢「一次性解鎖」（序列短播→暫停，避免 CriOS 一次多連播被拒）
  function unlockIOSAutoplaySeq() {
    if (!IS_IOS || iosUnlocked) return;
    iosUnlocked = true;
    document.removeEventListener('touchstart', unlockIOSAutoplaySeq, true);
    document.removeEventListener('pointerdown', unlockIOSAutoplaySeq, true);
    document.removeEventListener('click',       unlockIOSAutoplaySeq, true);

    const videos = $('.content-swiper video').toArray();
    let i = 0;
    const step = () => {
      if (i >= videos.length) {
        // 解鎖完立刻嘗試播 active（非同步也加 RAF）
        requestAnimationFrame(() => playActiveVideo(contentsSwiper));
        return;
      }
      const v = videos[i++];
      applyRenderHints(v);
      ensureVideoWired(v);
      try {
        const p = v.play();
        if (p && p.then) {
          p.then(() => { v.pause(); setTimeout(step, 80); }).catch(() => setTimeout(step, 80));
        } else {
          v.pause();
          setTimeout(step, 80);
        }
      } catch(e) {
        setTimeout(step, 80);
      }
    };
    step();
  }
  document.addEventListener('touchstart',  unlockIOSAutoplaySeq, true);
  document.addEventListener('pointerdown', unlockIOSAutoplaySeq, true);
  document.addEventListener('click',       unlockIOSAutoplaySeq, true);

  // ----------------初始：套 hint，非 iOS 直接播第一張
  function resetServiceSection() {
    $('.content-swiper video').each(function(){ applyRenderHints(this); });
    if (!IS_IOS) {
      const v = $('.content-swiper .swiper-slide-active video').get(0);
      if (v) primeAndPlay(v);
    }
  }
  resetServiceSection();

  //----------------置中 thumbs active slide（僅手機用）
  function centerThumbOnMobile(idx) {
    if (window.innerWidth < 992 && thumbsSwiper && typeof idx === 'number') {
      thumbsSwiper.slideTo(idx, 400, false);
    }
  }

  
  /* ---------------- 根據位置與大小計算active slider樣式---------------- */
  function drawLineToCircle(retry = 0) {
    if (window.innerWidth < 992) { $('.svg-lines-wrap').empty(); return; }
    let $wrap = $('.service__swiper');
    let $activeThumb = $('.thumbs-swiper .swiper-slide-thumb-active .thumbs_item');
    let $circle = $('.deco_circle');
    if (!$wrap.length || !$activeThumb.length || !$circle.length) return;
    if (
      !$activeThumb.is(':visible') ||
      $activeThumb.outerWidth() === 0 ||
      $wrap.width() === 0 ||
      retry > 20
    ) {
      if (retry < 21) setTimeout(() => drawLineToCircle(retry + 1), 75);
      else $('.svg-lines-wrap').empty();
      return;
    }
    let wrapOffset = $wrap.offset();
    let slideOffset = $activeThumb.offset();
    let slideWidth = $activeThumb.outerWidth();
    let slideHeight = $activeThumb.outerHeight();
    let x1 = slideOffset.left + slideWidth - wrapOffset.left;
    let y1 = slideOffset.top + slideHeight / 2 - wrapOffset.top;

    let circleOffset = $circle.offset();
    let circleWidth = $circle.width();
    let circleHeight = $circle.height();
    let cx = circleOffset.left + circleWidth / 2 - wrapOffset.left;
    let cy = circleOffset.top + circleHeight / 2 - wrapOffset.top;
    let r = circleWidth / 2;
    let dy = y1 - cy;
    if (Math.abs(dy) > r) { $('.svg-lines-wrap').empty(); return; }
    let dx = Math.sqrt(r*r - dy*dy);
    let x2 = cx - dx;
    let y2 = y1;
    let lineLength = Math.hypot(x2 - x1, y2 - y1);
    let svg = `
      <svg width="${$wrap.width()}" height="${$wrap.height()}" style="position:absolute;top:0;left:0;pointer-events:none;">
        <defs><linearGradient id="circle-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#26BADE"/><stop offset="100%" stop-color="#00A791"/></linearGradient>
        </defs>
        <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"
          stroke="#0EB3A1" stroke-width="1" stroke-linecap="round"
          style="stroke-dasharray:${lineLength};stroke-dashoffset:${lineLength}" class="animated-svg-line"/>
        <circle cx="${x2}" cy="${y2}" r="7.5" fill="url(#circle-gradient)" stroke="none"
          class="animated-svg-circle" style="opacity:0"/>
      </svg>`;
    $('.svg-lines-wrap').html(svg);
    setTimeout(() => {
      $('.svg-lines-wrap .animated-svg-line').addClass('play');
      setTimeout(() => {
        let $line = $('.svg-lines-wrap .animated-svg-line');
        $line.css({ 'stroke-dasharray': '4,7', 'stroke-dashoffset': '0' });
        $('.svg-lines-wrap .animated-svg-circle').addClass('show');
      }, 800);
    }, 20);
  }

  /* ---------------- Swiper: thumbs（原樣） ---------------- */
  thumbsSwiper = new Swiper('.thumbs-swiper', {
    breakpoints: {
      0:   { direction: 'horizontal', slidesPerView: 'auto', spaceBetween: 12, centeredSlides: true, slideToClickedSlide: true, allowTouchMove: true,  initialSlide: 0 },
      992: { direction: 'vertical',   slidesPerView: 6,     spaceBetween: 0,  centeredSlides: false, slideToClickedSlide: true, allowTouchMove: false }
    }
  });

  /* ---------------- Swiper: contents（CriOS 用 slide；其他維持 fade） ---------------- */
  /* ---------------- 手勢追蹤 ---------------- */
  const GESTURE = { active: false };
  const markGestureStart = () => { GESTURE.active = true; };
  const markGestureEnd   = () => { /* 給個很短的容忍窗，避免剛放手就失效 */ 
    setTimeout(() => { GESTURE.active = false; }, 0);
  };
  // 綁 DOM（保險）
  $('.content-swiper')
    .on('touchstart pointerdown mousedown', markGestureStart)
    .on('touchend pointerup mouseup touchcancel pointercancel', markGestureEnd);

  const EFFECT_FOR_THIS_DEVICE = (IS_CRIOS ? 'slide' : 'fade');
  contentsSwiper = new Swiper('.content-swiper', {
    slidesPerView: 1,
    effect: EFFECT_FOR_THIS_DEVICE,
    fadeEffect: { crossFade: true },     // 非 CriOS 才會用到
    speed: IS_CRIOS ? 420 : 600,
    thumbs: { swiper: thumbsSwiper },
    observer: true,
    observeParents: true,
    watchSlidesProgress: true,
    direction: 'horizontal',
    on: {
      /* 讓 Swiper 的手勢事件也能標記 */
      touchStart() { markGestureStart(); },
      touchEnd()   { markGestureEnd(); },
      init: function () {
        // 初始化 wiring 可見與鄰居
        preloadNeighbors(this);

        // 線段動畫穩定觸發
        forceLoadCircleImage(() => {
          setTimeout(drawLineToCircle, 100);
          setTimeout(drawLineToCircle, 300);
          setTimeout(drawLineToCircle, 600);
        });

        // 非 iOS 直接播第一張；iOS 待首次手勢解鎖後
        if (!IS_IOS) {
          stopAllVideosIn(this);
          primeAndPlay(getActiveVideo(this));
        }
      },

      activeIndexChange: function () {
        preloadNeighbors(this);
      },

      // 在同一個「滑動手勢」回合、transition 開始時就同步播放「即將成為 active 的那支」
      slideNextTransitionStart: function () {
        const targetIdx = Math.min(this.activeIndex, this.slides.length - 1);
        const v = getVideoByIndex(this, targetIdx);
        // 手勢回合同步 + 也預先載左右鄰居
        if (v) primeAndPlay(v, /* immediate */ IS_IOS && GESTURE.active);
        preloadNeighbors(this);
      },
      slidePrevTransitionStart: function () {
        const targetIdx = Math.max(this.activeIndex, 0);
        const v = getVideoByIndex(this, targetIdx);
        if (v) primeAndPlay(v, /* immediate */ IS_IOS && GESTURE.active);
        preloadNeighbors(this);
      },
      // riOS（iOS Chrome）在手機上不要把新 slide 先設為 hidden
      slideChangeTransitionStart: function () {
        if (window.innerWidth < 992) {
          if (IS_CRIOS) {
            // CriOS：避免 visibility 切換（保持可見，讓 play() 不被拒）
            if (this.el) this.el.style.overflow = 'hidden';
          } else {
            // 其它裝置維持你原本延遲顯示策略
            const slides = this.slides || [];
            const newIdx = this.activeIndex;
            const oldIdx = (typeof this.previousIndex === 'number') ? this.previousIndex : newIdx;
            if (this.el) this.el.style.overflow = 'hidden';
            for (let i = 0; i < slides.length; i++) {
              const s = slides[i];
              if (s.__vrTimer) { clearTimeout(s.__vrTimer); s.__vrTimer = null; }
              if (i === oldIdx) s.style.visibility = 'visible';
              else if (i === newIdx) {
                s.style.visibility = 'hidden';
                s.__vrTimer = setTimeout(() => { s.style.visibility = 'visible'; s.__vrTimer = null; }, 200);
              } else s.style.visibility = 'hidden';
            }
          }
        }
      },
      slideChange: function () {
        centerThumbOnMobile(this.activeIndex);
        preloadNeighbors(this);
        setTimeout(drawLineToCircle, 80);
      },

      // 切換完成 → 後備補播（iOS 需已解鎖）
      slideChangeTransitionEnd: function () {
        if (!(IS_IOS && !iosUnlocked)) {
          requestAnimationFrame(() => playActiveVideo(this));
        }
        // 還原手機 visibility 管控
        if (window.innerWidth < 992 && !IS_CRIOS) {
          const slides = this.slides || [];
          for (let i = 0; i < slides.length; i++) {
            const s = slides[i];
            if (s.__vrTimer) { clearTimeout(s.__vrTimer); s.__vrTimer = null; }
            s.style.visibility = '';
          }
        }
      },
    }
  });

  // ----------------thumbs 點擊：在「同一個點擊手勢」裡就直接播目標 index 的影片（滿足 iOS Chrome 要求）
  $('.thumbs-swiper').on('click', '.swiper-slide', function (e) {
    const idx = $(this).index();
    contentsSwiper.slideTo(idx);
    centerThumbOnMobile(idx);
    // 直接取該 index 的 video，同步播放
    const v = getVideoByIndex(contentsSwiper, idx);
    if (v) primeAndPlay(v, /*immediate*/ true);
    // 兜底：下一個 frame 再播一次，避免還在過場
    requestAnimationFrame(() => playActiveVideo(contentsSwiper));
    setTimeout(drawLineToCircle, 30);
  });

  // ----------------DOM 兜底：transition 結束或手勢釋放後再補播一次
  $('.content-swiper')
    .on('transitionend webkitTransitionEnd oTransitionEnd', '.swiper-wrapper', function (e) {
      if (e.target !== this) return;
      requestAnimationFrame(() => playActiveVideo(contentsSwiper));
      setTimeout(drawLineToCircle, 30);
    })
    .on('touchend pointerup mouseup', function () {
      requestAnimationFrame(() => playActiveVideo(contentsSwiper));
      setTimeout(drawLineToCircle, 30);
    });

  $(window).on('resize', function () {
    const idx = contentsSwiper ? contentsSwiper.activeIndex : 0;
    centerThumbOnMobile(idx);
    setTimeout(drawLineToCircle, 100);
  });

  /* ---------------- client swiper（原樣） ---------------- */
  clientSwiper = new Swiper('.client__swiper', {
    loop: false,
    effect: 'coverflow',
    centeredSlides: true,
    slidesPerView: 'auto',
    speed: 600,
    initialSlide: 2,
    coverflowEffect: { rotate: 0, stretch: 0, depth: 0, modifier: 1, slideShadows: false },
    breakpoints: { 0: { spaceBetween: 40 }, 992: { spaceBetween: 80 } }
  });
});

/* ---------------------------------------- [START] 技術＋設計交互動態 */
$(function () {
  function resetAll() {
    const $section = $('#Technical');
    $section.removeClass('show-dev show-design');
    $('#intro, .wave, #dev_title, #design_title')
      .removeClass('animated move-right move-left');
    $('#dev_con, #design_con').removeClass('animated in-right in-left');
    $('.technical__con').css('height', '');
    waveCenter();
  }
  resetAll();
  // ----------------高度設定
  function animateHeight($target) {
    const $con = $('.technical__con');
    $target.css({
      visibility: 'hidden',
      position: 'static',
      display: 'block'
    });
    const h = $target.outerHeight();
    $target.css({
      visibility: '',
      position: '',
      display: ''
    });
    $con.stop().animate({ height: h }, 400);
  }

  //----------------wave 只用 transform 動態控制
  function wavePush(direction) {
    const $wave = $('.wave');
    const $word = $wave.find('.word');
    const waveHeight = $wave.outerHeight();
    const wordHeight = $word.outerHeight();

    if (window.innerWidth < 1200) {
      // 先清除所有動態座標
      $wave.css({
        left: '50%',
        right: '',
        top: '',
        bottom: '',
        transform: 'translateX(-50%)'
      });

      const adjust = (wordHeight); // 字體一半高度

      if (direction === 'left') {
        // 向下
        $wave.css({
          top: 'auto',
          bottom: (-(waveHeight / 2) + (adjust * 1.4)) + 'px',
          transform: 'translateX(-50%)'
        });
      } else {
        // 向上
        $wave.css({
          top: (-(waveHeight / 2) + (adjust * 1.4)) + 'px',
          bottom: 'auto',
          transform: 'translateX(-50%)'
        });
      }
      return;
    }

    // ----------------1200以上維持 X 軸精算
    const $title = direction === 'left'
      ? $('#dev_title')
      : $('#design_title');
    const waveWidth = $wave.outerWidth();
    const wordWidth = $word.width();
    const margin = 10;
    const titleRect = $title[0].getBoundingClientRect();
    const centerX = window.innerWidth / 2;
    let offset = 0;

    if (direction === 'left') {
      offset = (titleRect.right - centerX) - (waveWidth / 2) + (2 * wordWidth) - margin;
      if (window.innerWidth < 1600) offset += 95;
    } else {
      offset = (titleRect.left - centerX) + (waveWidth / 2) - (2 * wordWidth) + margin;
      if (window.innerWidth < 1600) offset -= 95;
    }

    $wave.css({
      left: '50%',
      top: '50%',
      bottom: '',
      transform: `translate(calc(-50% + ${offset}px), -50%)`
    });
  }

  function waveCenter() {
    $('.wave').css({
      left: '50%',
      right: '',
      top: '50%',
      bottom: '',
      transform: 'translate(-50%, -50%)'
    });
  }

  // ----------------技術切換
  $('#to-dev, #to-dev-in').on('click', function (e) {
    e.preventDefault();

    // 平滑滾動到 #Technical
    $('html, body').animate({
      scrollTop: $('#Technical').offset().top
    }, 500);

    const $section = $('#Technical');
    $section.removeClass('show-design').addClass('show-dev');
    $('.wave').removeClass('animated move-right move-left');
    $('#intro, .wave, #design_title').addClass('animated move-right');
    $('#dev_title').removeClass('animated move-right move-left');
    $('#dev_con').addClass('animated in-right').removeClass('in-left');
    $('#design_con').removeClass('animated in-left in-right');
    animateHeight($('#dev_con'));
    wavePush('right');
  });

  // ----------------設計切換
  $('#to-design, #to-design-in').on('click', function (e) {
    e.preventDefault();

    // 平滑滾動到 #Technical
    $('html, body').animate({
      scrollTop: $('#Technical').offset().top
    }, 500);

    const $section = $('#Technical');
    $section.removeClass('show-dev').addClass('show-design');
    $('.wave').removeClass('animated move-right move-left');
    $('#intro, .wave, #dev_title').addClass('animated move-left');
    $('#design_title').removeClass('animated move-right move-left');
    $('#design_con').addClass('animated in-left').removeClass('in-right');
    $('#dev_con').removeClass('animated in-left in-right');
    animateHeight($('#design_con'));
    wavePush('left');
  });

  window.resetSectionS4 = resetAll;

  $(window).on('resize', function () {
    if ($('#Technical').hasClass('show-dev')) {
      animateHeight($('#dev_con'));
      wavePush('right');
    } else if ($('#Technical').hasClass('show-design')) {
      animateHeight($('#design_con'));
      wavePush('left');
    } else {
      $('.technical__con').css('height', '');
      waveCenter();
    }
  });
});

/* ---------------------------------------- [START] 節流、基本設定、開頭動畫 */
(function (window, document) {
  /* ---------------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	const body = document.body;
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	let ws = 0;
	function getScrollTop(target = window) {
		return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	}
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		ws = getScrollTop();
	}
	on(window, 'load', getWinSet);
	on(window, 'resize', throttle(getWinSet, 50, 100));

	/* ---------------------------------------- [START] 整頁 Scroll 監測 (Before) */
	var pageScrollCheckList = []; // 紀錄物件
	var pageScrollAdd = function (selector, buildFunction) {
		var el = document.querySelector(selector);
		if (el === null) {
			return false;
		}
		pageScrollCheckList.push({
			build: false,
			el: el,
			fun: buildFunction,
		});
	};
	var pageScrollClear = function () {
		pageScrollCheckList = Array.prototype.filter.call(pageScrollCheckList, function (item) {
			return item.build === false;
		});
	};

  /* ---------------------------------------- [START] 開頭動畫 + fallback 初始化 */
  gsap.registerPlugin(ScrollTrigger);

  const $opening = $('#opening');
  const $video = $('.first-Transition');
  const $maskFrame = $('#maskFrame');
  const v1 = $video[0];
  const isMobileW = window.innerWidth < 991;

  const introSteps = [
    { el: '.intro__first span:nth-child(1)', range: [0.36, 0.12] },
    { el: '.intro__first span:nth-child(2)', range: [0.48, 0.24] },
    { el: '.intro__sec span:nth-child(1)', range: [0.60, 0.36] },
    { el: '.intro__sec span:nth-child(2)', range: [0.72, 0.48] },
    { el: '.intro__forth', range: [0.84, 0.60] },
    { el: '#opening h4', range: [0.96, 0.72] },
    { el: '#intro_scroll', range: [0.96, 0.86] },
  ];

  const keyframes_pc = [
    { msizeX: 82, msizeY: 82, mx: 30, my: 10 },
    { msizeX: 90, msizeY: 120, mx: 17, my: -5 },
    { msizeX: 150, msizeY: 180, mx: -25, my: -35 },
    { msizeX: 350, msizeY: 350, mx: -100, my: -135 },
    { msizeX: 550, msizeY: 550, mx: -250, my: -140 },
    { msizeX: 750, msizeY: 750, mx: -395, my: -211 },
    { msizeX: 1050, msizeY: 1050, mx: -500, my: -200 },
    { msizeX: 1500, msizeY: 1500, mx: -730, my: -300 }
  ];

  const keyframes_mobile = [
    { msizeX: 82, msizeY: 82, mx: 10, my: -2 },
    { msizeX: 120, msizeY: 120, mx: -10, my: -10 },
    { msizeX: 150, msizeY: 150, mx: -25, my: -25 },
    { msizeX: 180, msizeY: 180, mx: -40, my: -40 },
    { msizeX: 300, msizeY: 300, mx: -160, my: -100 },
    { msizeX: 800, msizeY: 800, mx: -400, my: -235 },
    { msizeX: 1000, msizeY: 1000, mx: -550, my: -300 },
    { msizeX: 1200, msizeY: 1200, mx: -610, my: -350 }
  ];

  function getCurrentKeyframes() {
    return isMobileW ? keyframes_mobile : keyframes_pc;
  }
  function lerp(a, b, t) {
    return a + (b - a) * t;
  }
  function setMaskToStart() {
    const first = getCurrentKeyframes()[0];
    $maskFrame[0].style.setProperty('--msizeX', first.msizeX + 'vw');
    $maskFrame[0].style.setProperty('--msizeY', first.msizeY + 'vh');
    $maskFrame[0].style.setProperty('--mx', first.mx + 'vw');
    $maskFrame[0].style.setProperty('--my', first.my + 'vh');
  }
  setMaskToStart();

  /* ---------------------------------------- [LOAD fallback 與影片延遲保險機制] */
  function handleVideoFallback(videoId) {
    const $video = $('#' + videoId);
    const $fallbacks = $video.siblings('.video-fallback');

    if (!$video.length) return;

    let hasPlayed = false;
    let timeoutFallback;
    const delay = isMobileW ? 1000 : 300;

    timeoutFallback = setTimeout(() => {
      if (!hasPlayed) {
        $fallbacks.css('opacity', 1);
      }
    }, delay);

    $video.on('canplay', () => {
      hasPlayed = true;
      clearTimeout(timeoutFallback);
      gsap.to($fallbacks, { opacity: 0, duration: 0.5 });
      gsap.to($video, { opacity: 1, duration: 0.6 });
    });

    $video.on('error', () => {
      $fallbacks.css('opacity', 1);
    });

    try {
      $video[0].load();
    } catch (e) {
      console.warn('影片載入失敗：', videoId);
    }
  }

  ['video2', 'video3', 'video4'].forEach(id => {
    handleVideoFallback(id);
  });

  /* ---------------------------------------- [影片預載處理] */
  function forcePreloadVideo(video) {
    if (!video) return;
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.then(() => {
        video.pause();
        video.currentTime = 0;
      }).catch((err) => {
        console.warn('📛 preload 播放失敗', err);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    ['#video2', '#video3', '#video4'].forEach(id => {
      const v = document.querySelector(id);
      if (v) forcePreloadVideo(v);
    });
  });
  /* ---------------------------------------- [START] 調整chrome browser跳動問題 */

	ScrollTrigger.config({
    ignoreMobileResize: true,
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,orientationchange"
  });

  /* ---------------------------------------- 開頭動畫 */
  let hasUserScrolled = false;
  window.addEventListener('scroll', () => {
    hasUserScrolled = true;
  }, { once: true });

  function openingAni() {
    const keyframes = getCurrentKeyframes();
    const totalFrames = keyframes.length;
    let hasPlayed = false;

    ScrollTrigger.create({
      trigger: $opening,
      start: 'top top',
      scrub: true,
      pin: true,
      anticipatePin: 1,
      onUpdate(self) {
        const progress = self.progress;
        if (!hasPlayed && progress > 0 && hasUserScrolled) {
          try {
            v1.currentTime = 0;
            v1.muted = true;
            v1.play();
            hasPlayed = true;
          } catch (e) {}
        }

        const i = Math.floor(progress * (totalFrames - 1));
        const next = Math.min(i + 1, totalFrames - 1);
        const t = (progress * (totalFrames - 1)) % 1;
        const c = keyframes[i];
        const n = keyframes[next];

        const msizeX = lerp(c.msizeX, n.msizeX, t);
        const msizeY = lerp(c.msizeY, n.msizeY, t);
        const mx = lerp(c.mx, n.mx, t);
        const my = lerp(c.my, n.my, t);

        $maskFrame[0].style.setProperty('--msizeX', msizeX + 'vw');
        $maskFrame[0].style.setProperty('--msizeY', msizeY + 'vh');
        $maskFrame[0].style.setProperty('--mx', mx + 'vw');
        $maskFrame[0].style.setProperty('--my', my + 'vh');

        introSteps.forEach(({ el, range }) => {
          const [start, end] = range;
          const dom = document.querySelector(el);
          if (!dom) return;
          const shouldHide = progress >= end;
          gsap.to(dom, {
            opacity: shouldHide ? 0 : 1,
            y: shouldHide ? 20 : 0,
            duration: 0.5,
            ease: 'power2.out'
          });
        });
      },
      onLeave() {
        try { v1.pause(); } catch (e) {}
        gsap.to('#video1', {
          opacity: 0,
          duration: 0.3,
          onStart: () => $('#video1').css({ 'pointer-events': 'none' }),
          onComplete: () => $('#video1').css('display', 'none')
        });
      },
      onEnter() {
        $('#opening .intro__text').css({ display: 'block', pointerEvents: 'auto' });
      },
      onEnterBack() {
        $('#video1').css({ opacity: 0, display: 'block', pointerEvents: 'auto' });
        gsap.to('#video1', { opacity: 1, duration: 0.6 });
        try { v1.currentTime = 0; v1.play(); } catch (e) {}
        hasPlayed = false;
      }
    });
  }
  openingAni();
  /* ---------------------------------------- 關於我們動畫 */
  function aboutAni() {
    const $about = $('#About');
    const aboutEl = $about[0];
    const contentEl =
      $about.find('.about__inner')[0] ||
      (aboutEl ? aboutEl.firstElementChild : null) ||
      aboutEl;

    const v2 = document.querySelector('#video2');
    const v3 = document.querySelector('#video3');
    let hasSwitched = false;

    // 以建立當下 viewport 高度鎖定 pin 長度（像素）
    const BASE_VH = (window.visualViewport?.height || window.innerHeight);
    const ABOUT_LEN_PX = Math.round(BASE_VH);

    // ===== 這裡只算「需要補的差值」，不跟既有內距疊加 =====
    const GAP_DESKTOP = 30;
    const GAP_MOBILE  = 20;
    const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;
    const getHeaderH = () => {
      const el = document.getElementById('header');
      return el ? Math.round(el.getBoundingClientRect().height) : 0;
    };

    // 建立/取得 spacer（放在 #About 的第一個子元素前）
    let spacer = aboutEl.querySelector(':scope > .about-gap-spacer');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'about-gap-spacer';
      Object.assign(spacer.style, {
        width: '100%',
        height: '0px',
        pointerEvents: 'none',
        flex: '0 0 auto'
      });
      aboutEl.insertBefore(spacer, contentEl);
    }

    // 依現況動態計算「還需要補多少」才能剛好= Header + 50/20
    function computeSpacerHeight() {
      if (!aboutEl || !contentEl) return 0;
      const desired = getHeaderH() + (isDesktop() ? GAP_DESKTOP : GAP_MOBILE);

      // 先把 spacer 清零來量「目前已經有的上緣距離」
      const prev = spacer.style.height;
      spacer.style.height = '0px';

      const parentTop  = aboutEl.getBoundingClientRect().top;
      const contentTop = contentEl.getBoundingClientRect().top;
      const currentGap = Math.round(contentTop - parentTop);

      const delta = Math.max(0, desired - currentGap);

      // 還原（下面會立刻覆蓋成正確值）
      spacer.style.height = prev;
      return delta;
    }

    function applySpacer() {
      spacer.style.height = computeSpacerHeight() + 'px';
    }

    // 初次套用
    applySpacer();

    // === GSAP動畫 ===
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: aboutEl,
        start: 'top top',                 // 不動 start
        end: () => `+=${ABOUT_LEN_PX}`,   // 固定像素長度（相對 start）
        scrub: true,
        pin: true,
        pinType: 'fixed',
        anticipatePin: 1,
        pinSpacing: true,

        // 每次 refresh（包含方向改變/斷點切換）都重新精算 spacer
        onRefresh() { applySpacer(); },

        onEnter: () => {
          $('#video2').css({ display: 'block', opacity: 1 });
          $('#video3').css({ display: 'none',  opacity: 0 });
          try { v2.currentTime = 0; v2.play(); } catch (e) {}
        },
        onUpdate: (self) => {
          if (!hasSwitched && self.progress >= 0.67) {
            hasSwitched = true;

            const $video2 = $('#video2');
            const $video3 = $('#video3');
            $video3.css({ display: 'block', opacity: 0, visibility: 'visible' });

            v3.currentTime = 0; v3.load();
            const onReady = () => {
              v3.removeEventListener('canplay', onReady);
              const tl2 = gsap.timeline();
              tl2.to('#video2', {
                opacity: 0,
                duration: 0.5,
                onComplete: () => { try { v2.pause(); } catch (e) {} $video2.css({ display: 'none' }); }
              });
              tl2.to('#video3', {
                opacity: 1,
                duration: 0.6,
                onStart: () => { try { v3.play(); } catch (e) {} }
              }, '-=0.3');
            };
            v3.addEventListener('canplay', onReady, { once: true });
          }
        },
        onLeaveBack: () => {
          hasSwitched = false;

          const $v2 = $('#video2');
          const $v3 = $('#video3');
          $v2.css({ display: 'block', opacity: 0 });

          v2.currentTime = 0; v2.load();
          v2.addEventListener('canplay', () => {
            gsap.to('#video2', { opacity: 1, duration: 0.5 });
            gsap.to('#video3', {
              opacity: 0,
              duration: 0.5,
              onComplete: () => { try { v3.pause(); v3.currentTime = 0; } catch (e) {} $v3.css({ display: 'none' }); }
            });
            try { v2.play(); } catch (e) {}
          }, { once: true });
        }
      }
    });

    // 文案/圖片補間
    gsap.set([
      '.about__first h5',
      '.about__first p:nth-child(2)',
      '.about__first p:nth-child(3)',
      '.about__sec h5',
      '.about__sec p:nth-child(2)',
      '.about__sec p:nth-child(3)',
      '.about__img'
    ], { opacity: 0, y: 30 });

    tl.to('.about__first h5', { opacity: 1, y: 0, duration: 0.6 }, 0)
      .to('.about__first p:nth-child(2)', { opacity: 1, y: 0, duration: 0.6 }, '+=0.2')
      .to('.about__first p:nth-child(3)', { opacity: 1, y: 0, duration: 0.6 }, '+=0.2')
      .to('.about__sec h5', { opacity: 1, y: 0, duration: 0.6 }, '+=0.3')
      .to('.about__sec p:nth-child(2)', { opacity: 1, y: 0, duration: 0.6 }, '+=0.2')
      .to('.about__sec p:nth-child(3)', { opacity: 1, y: 0, duration: 0.6 }, '+=0.2')
      .to('.about__img', { opacity: 1, y: 0, duration: 0.8 }, '+=0.3');

    // 監聽視窗變化 → 重新精算（不做 transform、不回彈）
    const onResize = () => { applySpacer(); ScrollTrigger.refresh(); };
    window.addEventListener('orientationchange', onResize, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    // 也把計算方法掛到全域，方便你手動 debug
    window.__aboutApplySpacer = applySpacer;

    return tl.scrollTrigger;
  }

  // 重建
  if (window.aboutST && window.aboutST.kill) { try { window.aboutST.kill(true); } catch(e){} }
  window.aboutST = aboutAni();

  /* ---------------------------------------- Slogan動畫 */
  function introSloganAni() {
    const $slogan = $('#intro_slogan');
    const v4 = document.querySelector('#video4');
    const v3 = document.querySelector('#video3');
    const isMobile = window.innerWidth < 991;
    if (v4) v4.loop = true;

    gsap.set('#video4', { opacity: 0, visibility: 'hidden' });
    gsap.set($slogan.find('img'), {
      opacity: 0,
      visibility: 'hidden',
      x: isMobile ? -40 : 0,
      y: isMobile ? 0 : -40
    });

    ScrollTrigger.create({
      trigger: $slogan[0],
      start: 'top top',
      scrub: true,
      pin: true,
      anticipatePin: 1,
      onEnter: () => {
        const $video4 = $('#video4');
        const $video3 = $('#video3');
        $video4.css({ opacity: 0, visibility: 'visible' });
        v4.currentTime = 0;
        v4.load();
        v4.addEventListener('canplay', () => {
          const tl = gsap.timeline();
          tl.to('#video3', {
            opacity: 0,
            duration: 0.4,
            onComplete: () => {
              try { v3.pause(); v3.currentTime = 0; } catch (e) {}
              $video3.css('visibility', 'hidden');
            }
          });
          tl.to('#video4', {
            opacity: 1,
            duration: 0.6,
            onStart: () => { try { v4.play(); } catch (e) {} }
          }, '-=0.3');

          setTimeout(() => {
            gsap.to($slogan.find('img'), {
              opacity: 1,
              visibility: 'visible',
              x: 0,
              y: 0,
              duration: 0.8,
              stagger: 0.2,
              ease: 'power2.out'
            });
          }, 500);
        }, { once: true });

        const tryPlay = v4.play();
        if (tryPlay !== undefined) tryPlay.catch(e => console.warn('video4 播放失敗', e));
      },
      onLeaveBack: () => {
        gsap.to('#video4', {
          opacity: 0,
          duration: 0.5,
          onComplete: () => {
            $('#video4').css('visibility', 'hidden');
            try { v4.pause(); v4.currentTime = 0; } catch (e) {}
          }
        });
        gsap.to($slogan.find('img'), {
          opacity: 0,
          duration: 0.5,
          x: isMobile ? -40 : 0,
          y: isMobile ? 0 : -40,
          onComplete: () => {
            $slogan.find('img').css('visibility', 'hidden');
          }
        });
        try {
          $('#video3').css('visibility', 'visible');
          gsap.to('#video3', { opacity: 1, duration: 0.6 });
          v3.currentTime = 0;
          v3.play();
        } catch (e) {}
      }
    });
  }
  introSloganAni();

  /* ---------------------------------------- [START] 針對開頭動畫固定高度 */
  // ==== Mobile 進入 #Technical → 固定 #all_intro 高度；離開（往上）→ 解鎖 ====
  var MOBILE_BP = 992; // 與你現有邏輯一致：< 992 視為手機
  var $allIntro = $('#all_intro'); // index.pug 是 #all_intro.all_intro
  if (!$allIntro.length) return;

  var introLocked = false;
  var lockedHeight = 0;
  var resizeDebounce = null;

  function isMobile() { return window.innerWidth < MOBILE_BP; }

  // 量測 #all_intro 的完整內容高度（含內部 pin/absolute 等狀況）
  function measureAllIntro() {
    var el = $allIntro[0];
    if (!el) return 0;
    // 取 scrollHeight 與外高度的較大值，避免 pin 或 overflow 情況估不到
    return Math.max(el.scrollHeight, $allIntro.outerHeight(true));
  }

  function lockAllIntroHeight() {
    if (introLocked || !isMobile()) return;
    // 初次鎖定時量一次
    lockedHeight = measureAllIntro();
    if (lockedHeight <= 0) {
      // 偶發第一次量不到：下一個 frame 再試
      requestAnimationFrame(function(){ 
        lockedHeight = measureAllIntro();
        applyLock();
      });
    } else {
      applyLock();
    }
  }

  function applyLock() {
    if (lockedHeight > 0) {
      // 固定高度
      $allIntro
        .css({ height: lockedHeight + 'px', minHeight: '', overflowY: 'hidden' })
        .addClass('is-locked');
      introLocked = true;
    }
  }

  function unlockAllIntroHeight() {
    if (!introLocked) return;
    $allIntro.css({ height: '', minHeight: '' }).removeClass('is-locked');
    introLocked = false;
    lockedHeight = 0;
  }

  // 當內容真的「長高」時（例如 lazy 圖片或影片啟播），允許只「變大不變小」
  function maybeGrowLockToContent() {
    if (!introLocked) return;
    var h = measureAllIntro();
    if (h > lockedHeight) {
      lockedHeight = h;
      $allIntro.css('height', lockedHeight + 'px');
    }
  }

  // 監聽 iOS/Android 視窗高度亂跳（visualViewport）→ 我們不跟著縮，只在內容真的變高時才放大
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      if (!introLocked) return;
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(maybeGrowLockToContent, 120);
    }, { passive: true });
  }

  // 以 IntersectionObserver 監看「#Client + #Technical + #Contact」兩區為鎖定範圍
  function setupIntroLockZones() {
    // 桌機一律解鎖
    if (!isMobile()) { unlockAllIntroHeight(); return; }
    var client  = document.getElementById('Client'); 
    var tech = document.getElementById('Technical');
    var contact = document.getElementById('Contact');
    if (!tech || !client || !contact) return;

    // 先取消舊的觀察器
    if (setupIntroLockZones._io) { try { setupIntroLockZones._io.disconnect(); } catch(e){} }

    // 可見狀態旗標
    var inTech = false, inClient = false, inContact = false;

    // 進入任一鎖定區即鎖；兩者皆離開且已回到 Technical 之上才解鎖
    function recomputeLock() {
      if (inTech || inClient || inContact) {
        lockAllIntroHeight();
        return;
      }
      // 兩者皆不在視窗內 → 只在「往上回去、位於 #Technical 之上」時解鎖
      var tTop = $('#Client').offset() ? $('#Client').offset().top : 0;
      if (window.pageYOffset + 8 < tTop) {
        unlockAllIntroHeight();
      }
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var id = e.target.id;
        var isIn = !!e.isIntersecting;
        if (id === 'Client')    inClient = isIn; 
        if (id === 'Technical') inTech = isIn;
        if (id === 'Contact')   inContact = isIn;

        // 特殊處理：當目標剛離開，但其頂端仍在視窗上方，代表使用者往上滑
        if (!isIn) {
          var rect = e.target.getBoundingClientRect();
          // 若往上滑離開（top >= 0 代表仍在下方、不是我們要的情境，忽略）
          if (rect.top < 0) {
            // nothing extra
          }
        }

        recomputeLock();
      });
    }, {
      // 提前鎖：當底部還有 60% 視窗高沒進來就先鎖，避免邊緣抖動
      root: null,
      rootMargin: '0px 0px -60% 0px',
      threshold: [0, 0.01]
    });
    io.observe(client); 
    io.observe(tech);
    io.observe(contact);
    setupIntroLockZones._io = io;

    // 首載若一開始就在 #Client 或 #Technical 或 #Contact（或更下方），立即鎖
    var clTop = $('#Client').offset()    ? $('#Client').offset().top    : 0;
    var tTop = $('#Technical').offset() ? $('#Technical').offset().top : 0;
    var cTop = $('#Contact').offset() ? $('#Contact').offset().top : 0;
    var y = window.pageYOffset + window.innerHeight * 0.4;
    if ((tTop && y >= tTop) || (clTop && y >= clTop) || (cTop && y >= cTop)){
      lockAllIntroHeight();
    }
  }


  // 初始化與自適應
  $(function () {
    setupIntroLockZones();

    // 轉向/尺寸變動：若跨越手機/桌機分界，重建策略
    $(window).on('resize orientationchange', throttle(function () {
      var wasMobileLocked = isMobile() && introLocked;
      setupIntroLockZones();                // 重新掛觀察器（桌機會直接解鎖）
      if (wasMobileLocked) maybeGrowLockToContent(); // 手機內尺寸變動 → 允許只變大不變小
    }, 50, 100));

    // 回到前景保守校正一次
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && introLocked) {
        maybeGrowLockToContent();
      }
    }, false);
  });

  /* ---------------------------------------- [START] 整頁 Scroll 監測 (After) */
	var pageScrollThrottle = null;
	var pageScrollHandler = function () {
		for (var i = 0; i < pageScrollCheckList.length; i++) {
			if (isInViewport(pageScrollCheckList[i].el)) {
				pageScrollCheckList[i].fun();
				pageScrollCheckList[i].build = true;
			}
		}

		// Clear
		pageScrollClear();

		// Stop
		if (pageScrollCheckList.length === 0) {
			off(window, 'scroll', pageScrollThrottle);
		}
	};

	on(window, 'load', function() {
		pageScrollThrottle = throttle(pageScrollHandler, 50, 1000); // 節流作用
		on(window, 'scroll', pageScrollThrottle);
		pageScrollHandler();
	});
})(window, document);


